import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { HomeComponent } from './home.component';
import { pageGuardInjectable } from 'src/app/services/helpers/page-guard-injectable';
import { TestModule } from '../test/test.module';
import { SettingsModule } from '../settings/settings.module';


const routes: Routes = [
  {
    path: '', component: HomeComponent, children: [
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [pageGuardInjectable]
      },
      {
        path: 'masterdata',
        loadChildren: () => import('../masterdata/masterdata.module').then(m => m.MasterdataModule),
        canActivate: [pageGuardInjectable],
        canActivateChild: [pageGuardInjectable],
      },
      {
        path: 'gestione-documenti',
        loadChildren: () => import('../gestione-documenti/gestione-documenti.module').then(m => m.GestioneDocumentiModule),
        //canActivate: [pageGuardInjectable],
        //canActivateChild: [pageGuardInjectable],
      },

      {
        path: 'scansione-errori',
        loadChildren: () => import('../scansione-errori/scansione-errori.module').then(m => m.ScansioneErroriModule),
        //canActivate: [pageGuardInjectable],
        //canActivateChild: [pageGuardInjectable],
      },

      {
        path: 'gestione-errori',
        loadChildren: () => import('../gestione-errori/gestione-errori.module').then(m => m.GestioneErroriModule),
        //canActivate: [pageGuardInjectable],
        //canActivateChild: [pageGuardInjectable],
      },

      {
        path: 'report-errori',
        loadComponent: () => import('../gestione-errori/report-errori-soluzioni/report-errori-soluzioni.component').then(m => m.ReportErroriSoluzioniComponent),
        //canActivate: [pageGuardInjectable],
        //canActivateChild: [pageGuardInjectable]        
      },
      
      {
        path: 'user',
        loadChildren: () => import('../user/user.module').then(m => m.UserModule),
        canActivate: [pageGuardInjectable],
        canActivateChild: [pageGuardInjectable],
      },
      {
        path: 'test',
        loadChildren: () => TestModule,
        //  canActivate: [pageGuardInjectable]
      },

      {
        path: 'settings',
        loadChildren: () => SettingsModule,
      },
      {
        path: 'tickets',
        loadChildren: () => import('src/app/features/tickets/tickets.module').then(x => x.TicketsModule),
        canActivate: [pageGuardInjectable],
        canActivateChild: [pageGuardInjectable],
      },

    ]
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeRoutingModule { }
